import classNames from "classnames";
import { useContext, useState } from "react";

import { FORM_TYPES } from "src/app/modules/auth/constants";
import { ROUTES } from "src/config/constants";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { AccountsService } from "src/core/services/auth";

import authCSS from "../Auth.module.css";

const ForgottenPasswordForm = ({ changeForm = (formToDisplay = FORM_TYPES.LOGIN) => {}, onResetPassword = (success: boolean) => {} }) => {
  const [emailValue, setEmailValue] = useState("");
  const modalData = useContext(ModalContext);

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setEmailValue(newValue);
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const returnUrl = `${window.location.origin}${ROUTES.resetPassword}`;
    AccountsService.forgotPassword({ email: emailValue, returnUrl: returnUrl })
      .then((response: any) => {
        onResetPassword(true);
        modalData?.triggerSuccess(response);
      })
      .catch((e: ApiResult) => {
        onResetPassword(false);
        modalData?.triggerError(e);
      });
  };

  return (
    <div className="u-flex u-flex-column u-flex-items-center">
      <h3 className="u-t-primary-dark u-t-uppercase u-m0 u-pt10px u-pb30px">Zaboravili ste lozinku?</h3>
      <p className="u-pl10per u-pr10per u-t-align-center u-t-f18p u-t-w400 u-m0 u-pb40px">
        Unesite svoju email adresu i poslat ćemo vam link za ponovno postavljanje lozinke na uneseni email
      </p>

      <form onSubmit={handleSubmit} className={classNames("u-col-xs-12", "u-col-sm-7", "u-col-md-9", "u-col-lg-7", authCSS.loginForm)}>
        <div className="u-flex u-flex-column u-pb70px">
          <label htmlFor="email" className="u-t-f14p u-ml10px">
            Email
          </label>
          <input type="text" onChange={onEmailChange} className="u-t-f15p" required></input>
        </div>
        <div className="u-flex u-flex-content-center u-pb30px">
          <button
            type="submit"
            className={classNames(
              "u-bg-primary",
              "u-t-white",
              "u-cursor-pointer",
              "u-t-uppercase",
              "u-col-xs-12",
              "u-col-lg-10",
              "u-col-md-9",
              "u-font-family-inh",
              "u-t-f16p",
              "u-t-lh24",
              authCSS.button
            )}
          >
            Pošalji
          </button>
        </div>
      </form>

      <hr className="u-col-xs-12 u-col-sm-7 u-col-md-9 u-col-lg-7 u-bt0 u-bl0 u-br0 u-line-base" />

      <div className="u-t-f14p u-mb10px">
        <div>
          Nemate račun?
          <button
            className={classNames("u-font-family-inh", "u-t-underline", "u-cursor-pointer", "u-t-primary")}
            onClick={() => changeForm(FORM_TYPES.REGISTER)}
          >
            Registrirajte se
          </button>
        </div>
      </div>

      <div className="u-t-f14p u-mb30px">
        <div>
          Imate račun?
          <button className={classNames("u-font-family-inh", "u-t-underline", "u-cursor-pointer", "u-t-primary")} onClick={() => changeForm(FORM_TYPES.LOGIN)}>
            Prijavite se
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgottenPasswordForm;
